module.exports = __webpack_public_path__ + "static/Anzac-Bridge-a1c3997ee3b33d5285e9ef79842763d4.jpg";